import React from "react"
import { createPortal } from "react-dom"
import usePortal from "utils/usePortal"
import PropTypes, { node } from "prop-types"

const Portal = ({ id, children }) => {
  const target = usePortal(id)

  return <>{createPortal(children, target)}</>
}

Portal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([String, Number, node]).isRequired,
}

export default Portal
